"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationWithContext = exports.Translation = void 0;
var React = require("react");
var react_intl_1 = require("react-intl");
var renderChunk_1 = require("./renderChunk");
var TranslationContainer_1 = require("./TranslationContainer");
var IntlProvider_1 = require("../IntlProvider/IntlProvider");
var TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
var defaultElementConverters_1 = require("./defaultElementConverters");
var Translation = function (_super) {
  __extends(Translation, _super);
  function Translation() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Translation.prototype.render = function () {
    return React.createElement(TranslationWithContext, __assign({}, this.props));
  };
  return Translation;
}(React.Component);
exports.Translation = Translation;
var TranslationWithContext = function (_super) {
  __extends(TranslationWithContext, _super);
  function TranslationWithContext() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderMessage = function () {
      var chunks = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        chunks[_i] = arguments[_i];
      }
      var _a = _this.props,
        id = _a.id,
        values = _a.values,
        className = _a.className,
        innerRef = _a.innerRef,
        otherProps = __rest(_a, ["id", "values", "className", "innerRef"]);
      var _b = _this.context.container,
        Container = _b === void 0 ? TranslationContainer_1["default"] : _b;
      return React.createElement(Container, __assign({
        className: className,
        ref: innerRef
      }, otherProps), chunks.map(renderChunk_1.renderChunk));
    };
    return _this;
  }
  TranslationWithContext.prototype.render = function () {
    var _a = this.props,
      id = _a.id,
      values = _a.values;
    var _b = this.context.elementConverters,
      elementConverters = _b === void 0 ? defaultElementConverters_1.defaultElementConverters : _b;
    return React.createElement(IntlProvider_1.IntlProvider, null, React.createElement(react_intl_1.FormattedMessage, {
      id: id,
      values: __assign(__assign({}, elementConverters), values)
    }, this.renderMessage));
  };
  TranslationWithContext.contextType = TranslationProvider_1.TranslationProviderContext;
  TranslationWithContext.defaultProps = {
    values: {}
  };
  return TranslationWithContext;
}(React.PureComponent);
exports.TranslationWithContext = TranslationWithContext;